import script from "./studyBox.vue?vue&type=script&setup=true&lang=js"
export * from "./studyBox.vue?vue&type=script&setup=true&lang=js"

import "./studyBox.vue?vue&type=style&index=0&id=68308799&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68308799"]])

export default __exports__